{
  "product-happy-hour-dialog": {
    "buttons": {
      "close": "Đóng"
    },
    "text": {
      "happy-hour": "Khung giờ vàng",
      "to": "đến"
    }
  },
  "product-promotion-dialog": {
    "buttons": {
      "close": "Đóng"
    },
    "text": {
      "from-date-to-date": "từ {{from}} đến {{to}}"
    }
  },
  "salon-service-selection": {
    "buttons": {
      "select": "Chọn",
      "selected": "Đã chọn"
    },
    "text": {
      "discount-details": "Chi tiết giảm giá",
      "minutes": "phút"
    }
  }
}
